import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppBubble } from "@/components/ContactItems";
import { api } from "@/lib/api";

export function Layout({ children }) {
  useEffect(() => {
    const key = "mashiniya_visit_" + new Date().toISOString().slice(0, 10);
    if (!sessionStorage.getItem(key)) {
      api.post("/visitors/track").catch(() => {}).finally(() => {
        try { sessionStorage.setItem(key, "1"); } catch (e) { /* ignore */ }
      });
    }
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-[hsl(var(--background))]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppBubble />
    </div>
  );
}
